import { render, staticRenderFns } from "./GroupsAdmin.vue?vue&type=template&id=c59bf25c&scoped=true&"
import script from "./GroupsAdmin.vue?vue&type=script&lang=js&"
export * from "./GroupsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./GroupsAdmin.vue?vue&type=style&index=0&id=c59bf25c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59bf25c",
  null
  
)

export default component.exports